interface EnvConfig {
  NODE_ENV: 'development' | 'production' | 'test';
  AUTH_PROVIDER: 'mock' | 'cognito';
  COGNITO_USER_POOL_ID?: string;
  COGNITO_CLIENT_ID?: string;
  COGNITO_REGION?: string;
}

interface ProcessEnv {
  [key: string]: string | undefined;
}

const validateEnv = (env: ProcessEnv): EnvConfig => {
  const config: EnvConfig = {
    NODE_ENV: (env.NODE_ENV as EnvConfig['NODE_ENV']) || 'development',
    AUTH_PROVIDER: (env.REACT_APP_AUTH_PROVIDER as EnvConfig['AUTH_PROVIDER']) || 'mock',
  };

  // Only validate Cognito config if using Cognito auth
  if (config.AUTH_PROVIDER === 'cognito') {
    if (!env.REACT_APP_COGNITO_USER_POOL_ID) {
      throw new Error('REACT_APP_COGNITO_USER_POOL_ID is required when using Cognito auth');
    }
    if (!env.REACT_APP_COGNITO_CLIENT_ID) {
      throw new Error('REACT_APP_COGNITO_CLIENT_ID is required when using Cognito auth');
    }
    if (!env.REACT_APP_COGNITO_REGION) {
      throw new Error('REACT_APP_COGNITO_REGION is required when using Cognito auth');
    }

    config.COGNITO_USER_POOL_ID = env.REACT_APP_COGNITO_USER_POOL_ID;
    config.COGNITO_CLIENT_ID = env.REACT_APP_COGNITO_CLIENT_ID;
    config.COGNITO_REGION = env.REACT_APP_COGNITO_REGION;
  }

  return config;
};

// In a React app, process.env is replaced at build time with actual values
const processEnv: ProcessEnv = {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_AUTH_PROVIDER: process.env.REACT_APP_AUTH_PROVIDER,
  REACT_APP_COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  REACT_APP_COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID,
  REACT_APP_COGNITO_REGION: process.env.REACT_APP_COGNITO_REGION
};

export const env = validateEnv(processEnv);

// Only validate Cognito environment variables if using Cognito auth
if (env.AUTH_PROVIDER === 'cognito') {
  const requiredEnvVars = [
    'REACT_APP_COGNITO_USER_POOL_ID',
    'REACT_APP_COGNITO_CLIENT_ID',
    'REACT_APP_COGNITO_REGION'
  ] as const;

  requiredEnvVars.forEach(varName => {
    if (!process.env[varName]) {
      throw new Error(`Missing required environment variable for Cognito auth: ${varName}`);
    }
  });
} 